import {formatMoney} from '@shopify/theme-currency';

export const getCart = async () => {
    return fetch(window.localeUrl+'/cart.js', {
        method: 'GET',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
};

export const fetchCartSectionAndUpdate = async () => {
    await fetch('?section_id=main-content--cart').then(async (res) => {
        const text = await res.text();
        const parser = new DOMParser();
        const newSection = parser.parseFromString(text, 'text/html').querySelector('.cart__main');
        const cartSection = document.querySelector('.cart__main');
        if(cartSection && newSection) {
            cartSection.innerHTML = newSection.innerHTML;
            Shopify.AjaxifyCartPage().init();
            window.scrollTo(0, 0);
            document.dispatchEvent(new Event('resetAccordion'));

            const cartSidebar = document.querySelector('.cart__sidebar');
            const newCartSidebar = parser.parseFromString(text, 'text/html').querySelector('.cart__sidebar');
            if(cartSidebar && newCartSidebar) {
                cartSidebar.classList.remove('hidden');
                cartSidebar.innerHTML = newCartSidebar.innerHTML;
            }
        } else if (cartSection && newSection === null) {
            const newEmptySection = parser.parseFromString(text, 'text/html').querySelector('.page-section--cart-empty');
            if (newEmptySection) {
                cartSection.innerHTML = newEmptySection.innerHTML;
            }
            const cartSidebar = document.querySelector('.cart__sidebar');
            if(cartSidebar) {
                cartSidebar.classList.add('hidden');
            }
        } else if (cartSection === null && newSection) {
            location.reload();
        }
    }).catch((error) => {
        console.error('Error:', error);
    });
};

// Get current cart information and output as html
export const cartSubtotalUpdate = (cartData) => {
    const translations = window.translations;
    const _config = {
        cartCountSelector: '.cart__item-count',
        cartCountScreenReader: '.cart__item--count-sr'
    };

    // Get number of items in cart
    const cartItemsNum = parseInt(cartData.item_count);
    let cartItemsNumLabel;
    let cartItemsScreenReader;

    if (cartItemsNum > 1) {
        cartItemsNumLabel = translations.itemCountOther;
        cartItemsScreenReader = translations.itemCountOther;
    } else {
        cartItemsNumLabel = translations.itemCountOne;
        cartItemsScreenReader = translations.itemCountOne;
    }

    const subTotalLabel = translations.subTotalLabel;

    // Get items subtotal price
    const cartSubtotal = formatMoney(cartData.items_subtotal_price, theme.settingCurrencyFormat);
    const cartSubtotalContainers = document.querySelectorAll('.cart-subtotal__container');

    if (cartSubtotalContainers.length) {
        cartSubtotalContainers.forEach(container => {
            container.querySelector('.cart-info__item-count').textContent = `${subTotalLabel} (${cartItemsNum} ${cartItemsNumLabel})`;
            container.querySelector('.cart-info__subtotal').textContent = cartSubtotal;
        });
    }

    const cartSubtotalPrice = document.querySelector('.cart__subtotal-price');
    if(cartSubtotalPrice) {
        cartSubtotalPrice.textContent = cartSubtotal;
    }

    // Update cart counts
    const cartCounts = document.querySelectorAll(_config.cartCountSelector);
    const cartCountsScreenReader = document.querySelectorAll(_config.cartCountScreenReader);
    if (cartCounts?.length > 0) {
        cartCounts.forEach((cartCount) => {
            cartCount.textContent = cartData.item_count;
        });

        cartCountsScreenReader.forEach((cartCountScreen) => {
            cartCountScreen.textContent = `${cartData.item_count} ${cartItemsScreenReader}`;
        });
    }
};

export const createFormObject = (formData) => {
    let formObject = {};
    formData.forEach((value, key) => {
        if (!Reflect.has(formObject, key)) {
            formObject[key] = value;
            return;
        }
        if (!Array.isArray(formObject[key])) {
            formObject[key] = [formObject[key]];
        }
        formObject[key].push(value);
    });
    return formObject;
};
